import { RcFile } from "antd/lib/upload";
import { HttpUtils } from "./http-utils";
import Subjects from "../models/subjects";

const webApiUrl = "/darshana/api/tasks";

export interface SaveTaskRequest {
    source: number | null;
    numberInKim: number | null;
    theme: number | null;
    tags: string[],
    answer?: string | null,
    text?: string
}

export class TaskService {

    httpUtils: HttpUtils;

    constructor() {
        this.httpUtils = new HttpUtils();
    }

    search = async (subject: Subjects, urlParams: URLSearchParams) => {
        const options = {
            method: "GET",
        }
        const request = new Request(`${webApiUrl}/${subject}/search?${urlParams}`, options);
        const response = await fetch(request);

        return response.json();
    };

    create = async (subject: Subjects, params: SaveTaskRequest, successHandler: ((data: any) => any), errorHandler: ((data: string) => any)) => {

        const options = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params)
        }

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler, errorHandler);

        fetch(`${webApiUrl}/${subject}`, options).then(handler);
    }

    update(taskId: number, params: SaveTaskRequest, successHandler: () => void, errorHandler: (error: string) => void) {

        const options = {
            method: "PATCH",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params)
        }

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler, errorHandler);

        fetch(`${webApiUrl}/${taskId}`, options).then(handler);

    }

    getById(taskId: number, successHandler: (data: any) => any, errorHandler: ((data: string) => any)) {

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler, errorHandler);

        fetch(`${webApiUrl}/${taskId}`, { method: "GET" }).then(handler);
    }

    updateAnswer(taskId: number, answer: string, successHandler: () => any) {

        const options = {
            method: "PATCH",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ "answer": answer })
        }

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler);

        fetch(`${webApiUrl}/${taskId}/answer`, options).then(handler);
    }

    delete = async (taskId: number) => {
        return await fetch(`${webApiUrl}/${taskId}`, { method: "DELETE" });
    }

    getPhotoUploadUrl = (taskId: number, isMainPhoto: boolean) => {

        return isMainPhoto
            ? `${webApiUrl}/${taskId}/photos`
            : `${webApiUrl}/${taskId}/solution-photos`;
    }

    getPhotoDeleteUrl = (taskId: number, isMainPhoto: boolean, photoId: string) => {

        return isMainPhoto
            ? `${webApiUrl}/${taskId}/photos/${photoId}`
            : `${webApiUrl}/${taskId}/solution-photos/${photoId}`;
    }

    loadPhoto = async (file: RcFile, isMainPhoto: boolean, taskId: number) => {

        const formData = new FormData();
        formData.append('file', file as RcFile);

        return fetch(this.getPhotoUploadUrl(taskId, isMainPhoto), {
            method: 'POST',
            body: formData,
        });
    }

    deletePhoto = async (isMainPhoto: boolean, taskId: number, photoId: string, successHandler: () => any) => {

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler);

        fetch(this.getPhotoDeleteUrl(taskId, isMainPhoto, photoId), { method: 'DELETE' }).then(handler);
    }
}